import(/* webpackMode: "eager" */ "/app/src/app/[locale]/business-professional/page.tsx");
